<template>
  <YandexSmartCaptcha
    v-if="typeCaptcha === 'yandex_smartcaptcha'"
    ref="captcha"
    :sitekey="keyCaptcha"
    @verify="$emit('verify', $event)"
    @expired="$emit('expired', $event)"
    @render="$emit('render', $event)"
    @process-execute="$emit('process-execute', $event)"
  >
    <slot />
  </YandexSmartCaptcha>
  <GoogleCaptcha
    v-else
    ref="captcha"
    :sitekey="keyCaptcha"
    @verify="$emit('verify', $event)"
    @expired="$emit('expired', $event)"
    @render="$emit('render', $event)"
  >
    <slot />
  </GoogleCaptcha>
</template>

<script>
import YandexSmartCaptcha from './YandexSmartCaptcha/index.vue';
import GoogleCaptcha from './GoogleCaptcha.vue';
import { parseConfig } from '../../../../utils/json-config';

export default {
  name       : 'CaptchaUI',
  components : {
    GoogleCaptcha,
    YandexSmartCaptcha
  },
  data() {
    return {
      keyCaptcha  : parseConfig().captcha_public_key,
      typeCaptcha : parseConfig().captcha_type
    };
  },

  methods: {
    reset() {
      this.$refs.captcha.reset();
    },

    execute() {
      this.$refs.captcha.execute();
    }
  }
};
</script>
